module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Arlesheim-14400bcd1275e81b5d1a206e75070767.svg";